import {
  FinancialCompleteness,
  FinancialCompletenessMissingField,
  FinancialCompletenessStatus,
} from '../types/order';
import {
  asArray,
  asBoolean,
  asRecord,
  reportDtoAnomaly,
} from './common';

const FINANCIAL_COMPLETENESS_STATUSES: FinancialCompletenessStatus[] = ['COMPLETE', 'PENDING'];
const FINANCIAL_COMPLETENESS_MISSING_FIELDS: FinancialCompletenessMissingField[] = [
  'CUSTOMER_SALE_PRICES',
  'CUSTOMER_ORDER_COSTS',
  'SUPPLIER_PURCHASE_PRICES',
];

export function normalizeFinancialCompleteness(
  raw: unknown,
  entity: string,
): FinancialCompleteness | undefined {
  if (raw === undefined || raw === null) return undefined;

  const record = asRecord(raw);
  if (!record) {
    reportDtoAnomaly(entity, 'root', raw);
  }

  const status = FINANCIAL_COMPLETENESS_STATUSES.includes(record?.status as FinancialCompletenessStatus)
    ? record?.status as FinancialCompletenessStatus
    : 'PENDING';
  const missing = asArray(record?.missing, (item) => String(item))
    .filter((item): item is FinancialCompletenessMissingField => (
      FINANCIAL_COMPLETENESS_MISSING_FIELDS.includes(item as FinancialCompletenessMissingField)
    ));

  return {
    status,
    missing,
    salePricesComplete: record?.salePricesComplete == null ? undefined : asBoolean(record?.salePricesComplete),
    customerOrderCostsComplete: record?.customerOrderCostsComplete == null ? undefined : asBoolean(record?.customerOrderCostsComplete),
    purchasePricesComplete: record?.purchasePricesComplete == null ? undefined : asBoolean(record?.purchasePricesComplete),
  };
}
